export default __webpack_public_path__ + "static/banner-logo-0a325c31598aee6e64de040e365cd1d2.png";